import { gtm } from "@config/gtm";
import { HelmetComponent } from "@config/HelmetComponent";
import DateFnsUtils from "@date-io/date-fns";
import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import { ThemeProvider } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { PrismicProvider } from "@prismicio/react";
import { BaseMuiTheme } from "@theme";
import { handleUTMParams } from "@utils/utmHandler";
import React, { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Link } from "react-router-dom";
import { AppProvider } from "./contexts/Context";
import { defaultLocale, dynamicActivate } from "./i18n";
import { client } from "./prismic";
import { AppRoutes } from "./routers";

const gtmId = "GTM-5ND2P9W";

function App() {
  React.useEffect(() => {
    // With this method we dynamically load the catalogs
    dynamicActivate(defaultLocale);
  }, []);

  useEffect(() => {
    gtm.initialize({
      containerId: gtmId,
    });
  }, []);

  useEffect(() => {
    handleUTMParams();
  }, []);

  return (
    <PrismicProvider client={client} internalLinkComponent={({ href, ...props }) => <Link to={href} {...props} />}>
      <HelmetProvider>
        <ThemeProvider theme={BaseMuiTheme}>
          <I18nProvider i18n={i18n}>
            <AppProvider>
              <>
                <HelmetComponent />
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <AppRoutes />
                </MuiPickersUtilsProvider>
              </>
            </AppProvider>
          </I18nProvider>
        </ThemeProvider>
      </HelmetProvider>
    </PrismicProvider>
  );
}

export default App;
